import React from 'react';
import api from 'api';
import ModalFormCustomer from './ModalFormCustomer';
import { DEFAULT_LANGUAGE } from '../../../../config';

class CustomerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleCustomerUpdated = this.handleCustomerUpdated.bind(this);
  }
  render() {
    const customer = this.props.customer;
    const entity = customer.entity || {};
    const address = entity.primary_address || {};
    const country = address.country || {};
    return (
      <div>
        <table className="table table-bordered table-striped details">
          <thead>
            <tr className="info">
              <th colSpan="2">
                Customer details
                &nbsp; <button onClick={ this.toggleModaleCustomer.bind(this, true) } className="btn btn-primary btn-sm" title="Edit customer"><i className="fas fa-edit"/></button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>First name</td>
              <td>{ entity.first_name }</td>
            </tr>
            <tr>
              <td>Last name</td>
              <td>{ entity.last_name }</td>
            </tr>
            <tr>
              <td>Country</td>
              <td>{ country.name ? (country.name.$i18n || {})[DEFAULT_LANGUAGE] : '' } ({ customer.language })</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{ entity.primary_email }</td>
            </tr>
            <tr>
              <td>Address</td>
              <td>{ displayAddress(address) }</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{ entity.primary_phone }</td>
            </tr>
          </tbody>
        </table>
        {
          this.props.showModalCustomer
            ? <ModalFormCustomer
                for="edit"
                title="Edit customer"
                customerId={ customer.id }
                onClose={ this.toggleModaleCustomer.bind(this, false) }
                onCustomerSaved={ this.handleCustomerUpdated } />
            : null
        }
      </div>
    );
  }

  toggleModaleCustomer(bool) {
    this.props.api.customer.setData({ showModalCustomer: bool });
  }
  handleCustomerUpdated(customer) {
    this.toggleModaleCustomer(false);
    if (this.props.onCustomerUpdated) this.props.onCustomerUpdated(customer);
  }
}

function displayAddress(address) {
  if (!address) { return ''; }
  return `${address.line1 || ''} ${address.postcode || ''} ${address.city || ''}`;
}

export default api.connect(CustomerDetails, 'customer');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/CustomerDetails.jsx